<template>
  <div id="RequestFormList">
    <section v-if="!isPrintModalActive">
      <div id="container-center">
        <div class="labelTitle lable">検査申請一覧</div>
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>受付<br>番号</th>
              <td><input type="text" v-model="searchConditions.receiptNumber"/></td>
              <th>種別</th>
              <td><select v-model="searchConditions.kind">
                <option></option>
                <option v-for="kind in kindList" :key="kind.label" :value="kind.value">{{kind.label}}</option>
              </select></td>
              <th>機種</th>
              <td>
                <select v-model="searchConditions.instrumentKind">
                  <option value=""></option>
                  <option
                    v-for="instrument in filteredInstrumentKindOptions"
                    :key="instrument.value"
                    :value="instrument.value"
                  >
                    {{ instrument.label }}
                  </option>
                </select>
              </td>
              <th style="font-size: 11px">いびき<br>センサー</th>
              <td><select v-model="searchConditions.snoreSensor"><option></option><option value="1">無</option><option value="2">有</option></select></td>
            </tr>
            <tr>
              <th>進捗<br>状況</th>
              <td><select v-model="searchConditions.progress">
                <option></option>
                <option v-for="item in progressList" :key="item.code" :value="item.code">{{item.name}}</option>
              </select></td>
              <th>診察券ID</th>
              <td><input type="text" v-model="searchConditions.patientId"/></td>
              <th>患者名</th>
              <td><input type="text" v-model="searchConditions.patientName"/></td>
              <th>報告書ダウンロード</th>
              <td><select v-model="searchConditions.downloadFlag"><option value=""></option><option value="0">未</option><option value="1">済</option></select></td>
            </tr>
            <tr>
              <!-- 医療機関の場合非表示 -->
              <th v-if=!isHospital>医療機関名</th>
              <td v-if=!isHospital><input type="text" v-model="searchConditions.hospital"/></td>
              <th>検査期間</th>
              <td><b-checkbox class="cstmCheckBox" v-model="searchConditions.returnDelay" style="margin-left:10px; margin-top:2px;">超過</b-checkbox></td>
            </tr>
            <tr>
              <th>申込日</th>
              <td colspan="3"><input type="date" style="width:200px" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" style="width:200px" v-model="searchConditions.applicationDateEnd"/></td>
              <th>完了日</th>
              <td colspan="3"><input type="date" style="width:200px" v-model="searchConditions.completionDateStart"/> ～ <input type="date" style="width:200px" v-model="searchConditions.completionDateEnd"/></td>
            </tr>
            <tr>
              <th>AHI</th>
              <td colspan="3">
                <input
                  type="number"
                  step="0.1"
                  v-model="searchConditions.ahiFrom"
                  style="width: 200px;"
                />
                ～
                <input
                  type="number"
                  step="0.1"
                  v-model="searchConditions.ahiTo"
                  style="width: 200px;"
                />
              </td>
              <th>CVHRI</th>
              <td colspan="3" style="flex: auto;">
              <input
                type="number"
                step="0.1"
                v-model="searchConditions.cvhriFrom"
                style="width: 100px;"
              />
              ～
              <input
                type="number"
                step="0.1"
                v-model="searchConditions.cvhriTo"
                style="width: 100px;"
              />
              <select v-model="searchConditions.cvhriFlag" style="width: 150px; margin-left: 70px;margin-right: 70px;">
                <option></option>
                <option :value="1">算出不可</option>
              </select>
            </td>
            </tr>
          </table>
          <div class="searchButton-area">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
            <b-button class="backbutton is-primary" @click="back">戻る</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="data.length > 0">
          <div style="float:left">
            <b-button v-if="!isOpen" @click="isOpen=true" class="is-primary" icon-left="table-column-width" >列選択</b-button>
            <b-button v-if="isOpen" @click="isOpen=false" class="is-primary" icon-left="close-box-outline" >閉じる</b-button>
            <div v-if="isOpen" style="clear:both; height:0px;" >
              <div class="box selectColumn">
                <div style="height:30px;">
                  <b-checkbox class="columnCheckBox" v-model="isAllChecked" @input="changeAllCheckBox" >全てチェック</b-checkbox>
                  <a style="float:right;" @click="isOpen=false"><b-icon icon="close"/></a>
                </div>
                <b-checkbox class="columnCheckBox" v-model="columns.receiptNumber.checked" @input="changeCheckBox(columns.receiptNumber)" >受付番号</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.kind.checked" @input="changeCheckBox(columns.kind)" >種別</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.instrumentKind.checked" @input="changeCheckBox(columns.instrumentKind)" >機種</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.snoreSensor.checked" @input="changeCheckBox(columns.snoreSensor)" >いびきセンサー</b-checkbox>
                <b-checkbox v-if="!isHospital" class="columnCheckBox" v-model="columns.hospital.checked" @input="changeCheckBox(columns.hospital)" >医療機関名</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.patientId.checked" @input="changeCheckBox(columns.patientId)" >診察券ID</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.patientName.checked" @input="changeCheckBox(columns.patientName)" >患者名</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.applicationDate.checked" @input="changeCheckBox(columns.applicationDate)" >申込日</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.completionDate.checked" @input="changeCheckBox(columns.completionDate)" >完了日</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.progress.checked" @input="changeCheckBox(columns.progress)" >進捗状況</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.ahi.checked" @input="changeCheckBox(columns.ahi)" >AHI</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.cvhri.checked" @input="changeCheckBox(columns.cvhri)" >CVHRI(最大値)</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.report.checked" @input="changeCheckBox(columns.report)" >レポート</b-checkbox>
                <b-checkbox v-if="isHospital" class="columnCheckBox" v-model="columns.quickOrder.checked" @input="changeCheckBox(columns.quickOrder)" >クイックオーダー</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.print.checked" @input="changeCheckBox(columns.print)" >申込印刷</b-checkbox>
                <b-checkbox class="columnCheckBox" v-model="columns.contact.checked" @input="changeCheckBox(columns.contact)" >問い合わせ</b-checkbox>
              </div>
            </div>
          </div>
          <div>
            <span class="result-count">件数：{{data.length}}件</span>
            <b-table
              id="requestFormListTable"
              :data="data"
              :paginated="isPaginated"
              per-page="100"
              pagination-position="both"
              default-sort="receiptNumber"
              default-sort-direction="desc"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column :visible="columns.receiptNumber.checked" field="receiptNumber" label="受付番号" :width="columns.receiptNumber.width" centered sortable>
                  <a @click="showDetail(props.row.detailKind, props.row.progress,props.row,false)">{{props.row.receiptNumber}}</a>
                  <span v-if="props.row.depositMachineFlag" class="depo"/>
                </b-table-column>
                <b-table-column :visible="columns.kind.checked" field="kind" label="種別" :width="columns.kind.width" sortable>{{props.row.kind}}</b-table-column>
                <b-table-column :visible="columns.instrumentKind.checked" field="instrumentKind" label="機種" :width="columns.instrumentKind.width" sortable>{{props.row.instrumentKind}}</b-table-column>
                <b-table-column :visible="columns.snoreSensor.checked" field="snoreSensor" label="いびき
                センサー" :width="columns.snoreSensor.width" sortable >{{props.row.snoreSensor | snoreSensorFilter()}}</b-table-column>
                <b-table-column v-if=!isHospital :visible="columns.hospital.checked" field="hospital" label="医療機関名" :width="columns.hospital.width" sortable>{{props.row.hospital}}</b-table-column>
                <b-table-column :visible="columns.patientId.checked" field="patientId" label="診察券ID" :width="columns.patientId.width" sortable>{{props.row.patientId}}</b-table-column>
                <b-table-column :visible="columns.patientName.checked" field="patientName" label="患者名" :width="columns.patientName.width" sortable>{{props.row.patientName}}</b-table-column>
                <b-table-column :visible="columns.applicationDate.checked" field="applicationDate" label="申込日" :width="columns.applicationDate.width" centered sortable>{{props.row.applicationDate }}</b-table-column>
                <b-table-column :visible="columns.completionDate.checked" field="completionDate" label="完了日" :width="columns.completionDate.width" centered sortable>{{ props.row.completionDate }}</b-table-column>
                <b-table-column :visible="columns.progress.checked" field="progress" label="進捗状況" :width="columns.progress.width" centered sortable>
                  <span :class="getTabClass4RequestStatus(props.row.progress)">
                    {{getProgres(props.row.progress)}}
                  </span>
                </b-table-column>
                <b-table-column :visible="columns.ahi.checked" field="ahi" label="AHI" :width="columns.ahi.width" sortable>
                    {{props.row.applicationDetails.ahi}}
                </b-table-column>
                <b-table-column :visible="columns.cvhri.checked" field="cvhri" label="CVHRI (最大値)" :width="columns.cvhri.width" sortable>
                    {{ props.row.applicationDetails.cvhri != -1 ? props.row.applicationDetails.cvhri : '算出不可' }}
                </b-table-column>
                <b-table-column :visible="columns.report.checked" field="report" label="レポート" :width="columns.report.width" centered>
                  <template >
                    <b-button v-if="props.row.detailKind.indexOf('企業検診') !== -1 || !completedStatus.includes(props.row.progress) || props.row.historystatus == 103" :disabled=true class="btn btn--blue1">
                      レポート
                    </b-button>
                    <b-button v-else-if="filesExpiredCheck(props.row.reportFileList) && !showDownloadMark(props.row.reportFileList)" class="btn btn--blue1 btn--expired" @click="showErrorMessage(`レポートファイルは、ダウンロード後90日経過したため削除されました。<br>ご理解の程よろしくお願いいたします。`)">
                      レポート
                    </b-button>
                    <b-button v-else-if="filesExpiredCheck(props.row.reportFileList) && showDownloadMark(props.row.reportFileList)" class="btn btn--blue1 btn--expired" @click="showErrorMessage(`レポートファイルは、ダウンロード後90日経過したため削除されました。<br>ご理解の程よろしくお願いいたします。`)">
                      レポート(DL済)
                    </b-button>
                    <b-button v-else-if="!showDownloadMark(props.row.reportFileList)" class="btn btn--blue1" @click="showReportArea(props.row)">
                      レポート
                    </b-button>
                    <b-button v-else class="btn btn--blue3" @click="showReportArea(props.row)">
                      レポート(DL済)
                    </b-button>
                  </template>
                </b-table-column>
                <b-table-column v-if="isHospital" :visible="columns.quickOrder.checked" field="quickOrder" label="クイックオーダー" :width="columns.quickOrder.width" centered>
                  <b-button v-if="props.row.detailKind.indexOf('企業検診')==-1 && (props.row.progress==13 || props.row.progress==14 || props.row.progress==15 || props.row.progress==17 || props.row.progress==18)" class="btn btn--blue1" @click="showQuickOrder(props.row.detailKind, props.row.progress,props.row)">
                    次の処方へ
                  </b-button>
                  <b-button :disabled=true v-else class="btn btn--blue1">
                    次の処方へ
                  </b-button>
                </b-table-column>
                <b-table-column :visible="columns.print.checked" field="print" label="申込印刷" :width="columns.print.width" centered>
                  <a @click="printDetail(props.row.detailKind,props.row)">
                  <b-icon icon="printer"/></a>
                </b-table-column>
                <b-table-column :visible="columns.contact.checked" field="contact" label="問い合わせ" :width="columns.contact.width" centered>
                  <a :href=props.row.ref>
                    <b-icon icon="email-outline"/></a></b-table-column>
              </template>
            </b-table>
          </div>
          <div>
            <b-button class="backbutton is-primary" @click="back">戻る</b-button>
          </div>
        </div>
        <div class="result-area" v-if="dataBlank && data.length == 0">
          <div class="result-count">件数：{{data.length}}件</div>
        </div>
      </div>
      <floatingModal name="detail-Hst-modal" modalClass="detail-Hst-modal" @close="closeDetail" title="" width="800" height="480" top="100px" right="570px">
        <template v-if="isHospital && (isComplete || isCancel)">
          <div id="item-contens">
            <div class="card-content printMargin printBreakInside next-prescription-bar" style="text-align:right;">
              <b-button
                class="btn btn--blue1"
                @click="showQuickOrder(showDetailTargetData.orderType, showDetailTargetData.progress, detailQuickOrderRow)"
              >
                次の処方へ
              </b-button>
            </div>
            <div v-if="!isCancel" class="card-content next-prescription-bar-top">
              <table>
                <tr>
                  <th>AHI</th>
                  <td>
                    {{ showDetailTargetData.ahi }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </template>
        <hstRequestDetail :class="{ 'next-prescription-bar-top': isHospital && isCancel }" :data="showDetailTargetData" :requestCancel="requestCancel" @cancel="doCancel"/>
      </floatingModal>
      <floatingModal name="detail-Psg-modal" modalClass="detail-Psg-modal" @close="closeDetail" title="" width="640" height="480" top="100px" right="570px">
        <template v-if="isHospital && (isComplete || isCancel)">
          <div id="item-contens">
            <div  v-if="isComplete || isCancel" class="card-content printMargin printBreakInside next-prescription-bar" style="text-align:right;">
              <b-button class="btn btn--blue1" @click="showQuickOrder(showDetailTargetData.orderType, showDetailTargetData.progress, detailQuickOrderRow)">
                次の処方へ
              </b-button>
            </div>
            <div v-if="!isCancel" class="card-content next-prescription-bar-top">
              <table>
                <tr>
                  <th>AHI</th>
                  <td>
                    {{ showDetailTargetData.ahi }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </template>
        <psgRequestDetail :key="reset" :class="{ 'next-prescription-bar-top': isHospital && isCancel }" :data="showDetailTargetData" :canUpdate="canUpdate" v-on:reSearch="reSearch" @finish-psg="updateShowDetail" :requestCancel="requestCancel" @cancel="doCancel"/>
      </floatingModal>
      <floatingModal name="detail-Kenshin-modal" modalClass="detail-Kenshin-modal" @close="closeDetail" title="" width="900" height="480" top="100px" right="570px">
        <kenshinRequestDetail :data="showDetailTargetData"/>
      </floatingModal>
      <floatingModal name="detail-Holter-modal" modalClass="detail-Holter-modal" @close="closeDetail" title="" width="900" height="480" top="100px" right="570px">
        <template v-if="isHospital && (isComplete || isCancel)">
          <div id="item-contens">
            <div class="card-content printMargin printBreakInside next-prescription-bar" style="text-align:right;">
              <b-button class="btn btn--blue1" @click="showQuickOrder(showDetailTargetData.orderType, showDetailTargetData.progress, detailQuickOrderRow)">
                次の処方へ
              </b-button>
            </div>
          </div>
        </template>
        <holterRequestDetail :class="{ 'next-prescription-bar-top': isHospital && (isComplete || isCancel) }" :data="showDetailTargetData" :requestCancel="requestCancel" @cancel="doCancel" :isHideAnalysisOptions="true" :key="reset"/>
      </floatingModal>
      <floatingModal name="detail-HolterAnalysis-modal" modalClass="detail-HolterAnalysis-modal" @close="closeDetail" title="" width="900" height="480" top="100px" right="570px">
        <template v-if="isHospital && (isComplete || isCancel)">
          <div id="item-contens">
            <div class="card-content printMargin printBreakInside next-prescription-bar" style="text-align:right;">
              <b-button class="btn btn--blue1" @click="showQuickOrder(showDetailTargetData.orderType, showDetailTargetData.progress, detailQuickOrderRow)">
                次の処方へ
              </b-button>
            </div>
          </div>
        </template>
        <holterAnalysisRequestDetail :class="{ 'next-prescription-bar-top': isHospital && (isComplete || isCancel) }" :key="reset" :data="showDetailTargetData" :canUpdate="canUpdate" v-on:reSearch="reSearch" @finish-analysis="updateShowDetail" :requestCancel="requestCancel" @cancel="doCancel"/>
      </floatingModal>
      <floatingModal name="quick-order-modal" modalClass="quick-order-modal" @close="closeQuickOrder" title="" width="800" height="680" top="100px" right="570px">
        <template>
          <div id="item-contens">
            <div class="card-content margin-top printMargin printBreakInside">
              <table class="action-table">
                <tbody>
                  <tr>
                    <td class="cell">
                      <div class="row">
                        <div class="row-label">CPAP</div>
                        <div class="row-actions">
                          <b-button v-if="isEnableService(serviceId, service.cpap)" class="btn btn--blue1" style="font-size: small" @click="requestCpap(false)">CPAP処方</b-button>
                          <b-button v-if="isEnableService(serviceId, service.cpap) && userInfo.cpapDepositUseFlg" class="btn btn--blue1" style="font-size: small" @click="requestCpap(true)">CPAP預託</b-button>
                        </div>
                      </div>
                      <!-- スペーサー -->
                      <div class="row row-spacer"/>
                      <div class="row">
                        <div class="row-label">自宅配送(簡易検査)</div>
                        <div class="row-actions">
                          <template v-for="model in homeDeliveryHstGroups.easy">
                            <b-button
                              :key="model.value || model.id || model.label1"
                              v-if="canQuickOrderHst(model)"
                              class="btn btn--blue2"
                              :class="['btn-item', fontSizeClass(model.label1)]"
                              style="font-size: small"
                              @click="requestHst(model.label1)"
                            >
                              {{ model.label1 }}
                            </b-button>
                          </template>
                        </div>
                      </div>
                      <div class="row">
                        <div class="row-label">自宅配送(フルPSG)</div>
                        <div class="row-actions">
                          <template v-for="model in homeDeliveryHstGroups.full">
                            <b-button
                              :key="model.value || model.id || model.label1"
                              v-if="canQuickOrderHst(model)"
                              class="btn btn--blue2"
                              :class="['btn-item', fontSizeClass(model.label1)]"
                              style="font-size: small"
                              @click="requestHst(model.label1)"
                            >
                              {{ model.label1 }}
                            </b-button>
                          </template>
                        </div>
                      </div>
                      <div class="row">
                        <div class="row-label">PSG解析</div>
                        <div class="row-actions">
                          <b-button v-if="checkConnectionBtn(serviceId, service.psg, 'フルPSG解析')" class="btn btn--blue3" style="font-size: small" @click="requestFullPsg()">フルPSG解析</b-button>
                          <b-button v-if="checkConnectionBtn(serviceId, service.psg, '簡易PSG解析')" class="btn btn--blue3" style="font-size: small" @click="requestPsg()">簡易PSG解析</b-button>
                        </div>
                      </div>
                      <!-- スペーサー -->
                      <div class="row row-spacer"/>
                      <div class="row">
                        <div class="row-label">ホルター心電図</div>
                        <div class="row-actions">
                          <b-button v-if="isEnableService(serviceId, service.holter)" class="btn btn--blue4" style="font-size: small" @click="requestHolter()">自宅配送</b-button>
                          <b-button v-if="canRequestHolterInside" class="btn btn--blue4" style="font-size: small" @click="requestHolterInside()">院内貸出</b-button>
                        </div>
                      </div>
                      <!-- スペーサー -->
                      <div class="row row-spacer"/>
                      <div class="row">
                        <div class="row-label">施設紹介</div>
                        <div class="row-actions">
                          <b-button v-if="isEnableInstitution('hst')" class="btn btn--green" style="font-size: small" @click="introduce('hst')">睡眠宅配検査 施設</b-button>
                          <b-button v-if="isEnableInstitution('psg')" class="btn btn--green" style="font-size: small" @click="introduce('psg')">フルPSG 施設</b-button>
                          <b-button class="btn btn--green" style="font-size: small" @click="introduce('cpap')">CPAP 施設</b-button>
                          <b-button class="btn btn--green" style="font-size: small" @click="introduce('holter')">ホルター心電図 施設</b-button>
                        </div>
                      </div>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="shouldShowQuickOrderDetail" class="margin-top printMargin printBreakInside">
              <hstRequestDetail v-if="detailType === 'HST'" :data="quickOrderDetailSource"/>
              <psgRequestDetail v-else-if="detailType === 'PSG'" :data="quickOrderDetailSource"/>
              <holterRequestDetail v-else-if="detailType === 'Holter'" :data="quickOrderDetailSource" :isHideAnalysisOptions="true"/>
              <holterAnalysisRequestDetail v-else-if="detailType === 'Analysis'" :data="quickOrderDetailSource"/>
            </div>
          </div>
        </template>
      </floatingModal>
      <template v-if="isHospital">
        <floatingModal

          class="file-dialog"
          width="450"
          height="300"
          name="download-modal"
          modalClass="download-modal"
          top="100px"
          right="100px"
          @close="closeDownLoadFileList"
        >
          <FileListHospitalDialog :targetRowData="targetRowData" @download="download" @showDetail="showDetail"/>
        </floatingModal>
      </template>
      <template v-else>
        <floatingModal name="download-modal" modalClass="download-modal" @close="closeDownLoadFileList" title="" width="450" height="300" top="100px" right="100px">
          <downLoadFileList :fileList="fileListStr" :showNoteFlg="true" :showReportFileFlg="true" @download="download"/>
        </floatingModal>
      </template>
    </section>
    <section v-else-if="isPrintModalActive" class="printTarget" style="width:100%;">
      <div id="container-center">
        <h1 class="title has-text-centered printTarget">{{printTitle}}</h1>
        <div>
          <b-button class="is-primary unPrintTarget" style="text-align:right;" @click="isPrintModalActive=false">戻る</b-button>
          <b-button class="is-primary unPrintTarget" style="text-align:right;" icon-left="printer" @click="print">印刷</b-button>
          <section class="printTarget printMargin">
            <div id="item-contens">
              <div class="card-content margin-top">
                <table>
                  <tr><th>受付日時</th><td>{{printTargetReqDate}}</td></tr>
                  <tr><th>受付番号</th><td>{{printTargetReceiptNumber}}</td></tr>
                </table>
              </div>
            </div>
          </section>
          <hstRequestDetail v-if="printType=='HST'" class="printTarget" v-bind:data="printTargetData"/>
          <psgRequestDetail v-else-if="printType=='PSG'" class="printTarget" v-bind:data="printTargetData"/>
          <kenshinRequestDetail v-else-if="printType=='企業検診'" class="printTarget" v-bind:data="printTargetData" v-bind:isAccommodations="isAccommodations" v-bind:isPrint="true"/>
          <holterRequestDetail v-else-if="printType=='Holter'" class="printTarget" v-bind:data="printTargetData" :isHideAnalysisOptions="true"/>
          <holterAnalysisRequestDetail v-else-if="printType=='Analysis'" class="printTarget" v-bind:data="printTargetData"/>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {choicesType} from "@/components/mock/base/const.js";
import {role} from "@/components/mock/base/const.js";
import {service} from "@/components/mock/base/const.js";
import {requestStatus} from "@/components/mock/base/const.js";
import HSTRequestDetail from "@/components/mock/common/HSTRequestDetail";
import PSGRequestDetail from "@/components/mock/common/PSGRequestDetail";
import HolterRequestDetail from "@/components/mock/common/HolterRequestDetail";
import HolterAnalysisRequestDetail from "@/components/mock/common/HolterAnalysisRequestDetail";
import KenshinRequestDetail from "@/components/mock/common/KenshinRequestDetail";
import DownLoadFileList from "@/components/mock/common/DownLoadFileList";
import FileListHospitalDialog from "./components/FileListHospitalDialog.vue";
import floatingModal from "@/components/mock/common/FloatingModal";

const CORPORATE_KIND_LABEL = '企業検診'
const ALLOWED_CHOICES_TYPES = new Set(['1', '2', '3', '6', '14'])
const isCorporateKindLabel = (label) =>
  typeof label === 'string' && label.indexOf(CORPORATE_KIND_LABEL) !== -1
const buildKindLabelSet = (kindList) => {
  const labels = new Set()
  if (!Array.isArray(kindList)) {
    return labels
  }
  kindList.forEach((item) => {
    const label = item && item.label
    if (!label) {
      return
    }
    labels.add(label)
    if (isCorporateKindLabel(label)) {
      labels.add(CORPORATE_KIND_LABEL)
    }
  })
  return labels
}
const shouldFilterByLabel3 = (type) => String(type || '') === '2'
const passesLabel3Filter = (entry, allowedLabels, fallbackLabel) => {
  if (!entry || !entry.label3) {
    return false
  }
  if (!allowedLabels || allowedLabels.size === 0) {
    return true
  }
  if (allowedLabels.has(entry.label3)) {
    return true
  }
  return fallbackLabel ? entry.label3 === fallbackLabel : false
}
const getChoicesTypeOrder = (value) => {
  const num = Number(value)
  return Number.isNaN(num) ? Number.MAX_SAFE_INTEGER : num
}
const sortInstrumentOptions = (options) =>
  options.sort((a, b) => {
    const typeDiff =
      getChoicesTypeOrder(a.choicesType) - getChoicesTypeOrder(b.choicesType)
    if (typeDiff !== 0) {
      return typeDiff
    }
  })

export default {
  name: "RequestFormList",
  methods: {
    async prepareInstrumentKindOptions () {
      if (!sessionStorage.getItem('choiceMaster')) {
        await this.getChoiceMaster()
      }
      let options = this.buildInstrumentOptionsFromChoiceMaster()
      if (!options.length) {
        options = this.buildInstrumentOptionsFromKindMaster()
      }
      this.instrumentKindOptions = options
      this.ensureInstrumentKindInCurrentFilter()
    },
    buildInstrumentOptionsFromChoiceMaster () {
      const raw = sessionStorage.getItem('choiceMaster')
      if (!raw) {
        return []
      }
      let choiceMaster = []
      try {
        choiceMaster = JSON.parse(raw)
      } catch (error) {
        console.error(error)
        return []
      }
      const kindLabels = buildKindLabelSet(this.kindList)
      const restrictByKindLabel = kindLabels.size > 0
      const map = new Map()
      for (const group of choiceMaster) {
        if (!group || !group.choicesList) {
          continue
        }
        const type = String(group.choicesType || '')
        if (!type || !ALLOWED_CHOICES_TYPES.has(type)) {
          continue
        }
        for (const choice of group.choicesList) {
          if (choice && choice.deleteFlag) {
            continue
          }
          if (!choice || !choice.label1 || (!choice.label2 && type !== '6')) {
            continue
          }
          const kindLabel = type === '6' ? CORPORATE_KIND_LABEL : choice.label2
          if (!kindLabel) {
            continue
          }
          if (restrictByKindLabel && !kindLabels.has(kindLabel)) {
            continue
          }
          if (shouldFilterByLabel3(type) && !passesLabel3Filter(choice, kindLabels, kindLabel)) {
            continue
          }
          if (!map.has(choice.label1)) {
            map.set(choice.label1, {
              label: choice.label1,
              value: choice.label1,
              kindLabel,
              choicesType: type
            })
          }
        }
      }
      return sortInstrumentOptions(Array.from(map.values()))
    },
    buildInstrumentOptionsFromKindMaster () {
      const raw = sessionStorage.getItem('kindMaster')
      if (!raw) {
        return []
      }
      let kindMaster = []
      try {
        kindMaster = JSON.parse(raw)
      } catch (error) {
        console.error(error)
        return []
      }
      const kindLabels = buildKindLabelSet(this.kindList)
      const restrictByKindLabel = kindLabels.size > 0
      const map = new Map()
      for (const item of kindMaster) {
        if (!item) {
          continue
        }
        const type = String(item.choicesType || '')
        if (!type || !ALLOWED_CHOICES_TYPES.has(type)) {
          continue
        }
        if (!item.label1 || (!item.label2 && type !== '6')) {
          continue
        }
        const kindLabel = type === '6' ? CORPORATE_KIND_LABEL : item.label2
        if (!kindLabel) {
          continue
        }
        if (restrictByKindLabel && !kindLabels.has(kindLabel)) {
          continue
        }
        if (shouldFilterByLabel3(type) && !passesLabel3Filter(item, kindLabels, kindLabel)) {
          continue
        }
        if (!map.has(item.label1)) {
          map.set(item.label1, {
            label: item.label1,
            value: item.label1,
            kindLabel,
            choicesType: type
          })
        }
      }
      return sortInstrumentOptions(Array.from(map.values()))
    },
    ensureInstrumentKindInCurrentFilter () {
      const options = this.filteredInstrumentKindOptions
      if (!options.length) {
        this.searchConditions.instrumentKind = ''
        return
      }
      const exists = options.some(
        (option) => option.value === this.searchConditions.instrumentKind
      )
      if (!exists) {
        this.searchConditions.instrumentKind = ''
      }
    },
    back: function() {
      if(this.isFromHolterPatientReportRedirect) return this.$router.push({ path: "/guest/home" });
      this.$router.go(-1);
    },
    reSearch: function() {
      this.reSearchFlag = true
      this.doSearch()
    },
    doSearch: function() {
      // 検索ボタンを押した際に、詳細モーダル、クイックオーダーモーダル、レポートモーダルを閉じてから再検索をかける
      this.closeDetail()
      this.closeDownLoadFileList()
      this.closeQuickOrder()

      var excuteApi = this.getApplicationListPOST;
      var successCallBack = this.getApplicationListPOSTSuccess;
      var errorCallBack = this.getApplicationListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getApplicationListPOST: function (client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions))
      obj.kind = obj.kind.length !== 0 ? JSON.parse(obj.kind) : []
      obj.progress = obj.progress.length !== 0 ? JSON.parse(obj.progress) : []
      obj.belongsId = this.belongsId
      return client.apis.externalRequestSearch.getApplicationListPOST({
        body: obj
      })
    },
    getApplicationListPOSTSuccess: function (result) {
      // 検索結果取得（機種指定時はクライアント側で絞り込み）
      const instrumentFilter =
        this.searchConditions && this.searchConditions.instrumentKind
          ? String(this.searchConditions.instrumentKind).trim()
          : ''
      let rows = Array.isArray(result.obj) ? result.obj : []
      if (instrumentFilter) {
        rows = rows.filter(item => {
          const rowValue = item && item.instrumentKind
            ? String(item.instrumentKind).trim()
            : ''
          return rowValue === instrumentFilter
        })
      }

      const toNullableNumber = value => {
        if (value == null) return null

        const normalizedValue = typeof value === 'string'
          ? value.trim()
          : value

        if (normalizedValue === '') return null

        const num = Number(normalizedValue)
        return Number.isFinite(num) ? num : null
      }

      // b-table の field とソート対象をそろえるため、一覧行に数値化した値を持たせる
      rows = rows.map(row => {
        const applicationDetails = row && row.applicationDetails
          ? row.applicationDetails
          : {}

        return {
          ...row,
          ahi: toNullableNumber(applicationDetails.ahi),
          cvhri: toNullableNumber(applicationDetails.cvhri)
        }
      })

      // ===== AHI 範囲フィルタ（フロント側）=====
      const ahiFrom = toNullableNumber(this.searchConditions.ahiFrom)
      const ahiTo = toNullableNumber(this.searchConditions.ahiTo)

      if (ahiFrom !== null || ahiTo !== null) {
        rows = rows.filter(row => {
          const ahi = toNullableNumber(row.ahi)
          if (ahi === null) return false

          if (ahiFrom !== null && ahi < ahiFrom) return false
          if (ahiTo !== null && ahi > ahiTo) return false

          return true
        })
      }

      // ===== CVHRI 範囲フィルタ（フロント側）=====
      const cvhriFrom = toNullableNumber(this.searchConditions.cvhriFrom)
      const cvhriTo = toNullableNumber(this.searchConditions.cvhriTo)
      const cvhriNotCalculable = this.searchConditions.cvhriFlag

      if (cvhriNotCalculable) {
        rows = rows.filter(row => toNullableNumber(row && row.cvhri) === -1)
      } else if (cvhriFrom !== null || cvhriTo !== null) {
        rows = rows.filter(row => {
          const cvhri = toNullableNumber(row.cvhri)
          if (cvhri === null) return false

          if (cvhriFrom !== null && cvhri < cvhriFrom) return false
          if (cvhriTo !== null && cvhri > cvhriTo) return false

          return true
        })
      }
      this.data = rows
      
      var subject = encodeURI("【問合せ】 <ここに件名を記載してください> Philips Care Portal")
      for(var item of this.data){
        var body = encodeURI(
          "\n"
          + "【受付番号】" + item.receiptNumber +"\n"
          + "【医療機関】" + this.escapeStringForMailTo(item.hospital) +"\n"
          + "【検査種別】" + item.kind +"\n"
          + "\n"
          + "【お問い合わせ内容】\n"
          + "\n"
          + "<ここにお問い合わせ内容を記載してください。>\n"
        );
        item.ref = "mailto:"+ item.inqueryAddress + "?subject="+subject+"&body="+body;
      }
      if(this.reSearchFlag){
        var newTarget = this.data.find(val => {return val.receiptNumber == this.showDetailTargetReceiptNumber})
        if(newTarget){
          this.showDetail(newTarget.kind, newTarget.progress, newTarget)
          this.reset += 1;
        }
        this.reSearchFlag = false
      }
      
      if(this.data && this.data.length > 0){
        this.$nextTick(() => {
          this.chengeTableWidth(this.tableWidth);
        })
      }
      this.dataBlank = true;
      if(this.isFirstAutoSearch && this.data.length == 1){
        
        // ファイルが全て削除されていた場合は、ファイルのーモーダルを開かない
        if(!this.data[0].reportFileList.every(file => file && file.s3DeleteFlag === true)){
          this.showReportArea(this.data[0])
        }else{
          this.showErrorMessage(`レポートファイルは、ダウンロード後90日経過したため削除されました。\nご理解の程よろしくお願いいたします。`)
        }
        this.isFirstAutoSearch = false
      }
    },
    getApplicationListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getDetailTypeFromKind: function (kind) {
      if (!kind) {
        return null
      }
      if (kind.includes('HST')) {
        return 'HST'
      }
      if (kind.includes('PSG')) {
        return 'PSG'
      }
      if (kind.includes('企業検診')) {
        return 'Kenshin'
      }
      if (kind.includes('Holter')) {
        return 'Holter'
      }
      if (kind.includes('Analysis')) {
        return 'Analysis'
      }
      return null
    },
    showDetail: function(kind, progress, rowData, isReport) {
      this.reset += 1;
      if (!isReport) {
        this.closeQuickOrder()
        this.closeDownLoadFileList()
      }
      this.quickOrderTargetRow = rowData
      this.detailQuickOrderRow = rowData
      this.showDetailTargetReceiptNumber = rowData.receiptNumber
      this.showDetailTargetData = rowData.applicationDetails
      this.isComplete = this.completedStatus.includes(progress);
      this.isCancel = this.cancelStatus.includes(progress);
      // 再検査理由表示用
      this.showDetailTargetData.externalOperation = true;
      this.showDetailTargetData.progress = progress;
      this.showDetailTargetData.receiptNumber = rowData.receiptNumber;
      this.showDetailTargetData.orderType = rowData.detailKind;
      this.showDetailTargetData.depositMachineFlag = rowData.depositMachineFlag;
      this.showDetailTargetData.kind = kind;

      this.requestCancel = false
      this.closeDetail();
      if(kind.indexOf('HST') >= 0) {
        var today = this.yyyy_sla_MM_sla_dd(new Date())
        today = Number(today.replace(/[/]/g, ''))
        var shippDay = Number(rowData.desiredShippingDate.replace(/[/]/g, ''))
        this.requestCancel = [1,2,3].indexOf(rowData.progress) != -1 && !rowData.reExaminationFlag && today < shippDay
        this.version = rowData.version
        this.$modal.show('detail-Hst-modal')
      } else if(kind.indexOf('PSG') >= 0){
        this.requestCancel = [7,8,9].indexOf(rowData.progress) != -1
        this.version = rowData.version
        if(progress == 6 || progress == 7 || progress == 100){
          this.canUpdate = true;
        } else {
          this.canUpdate = false;
        }
        this.$modal.show('detail-Psg-modal')
      } else if(kind.indexOf('企業検診') >= 0)  {
        this.$modal.show('detail-Kenshin-modal')
      } else if(kind.indexOf('Holter') >= 0)  {
        var today = this.yyyy_sla_MM_sla_dd(new Date())
        today = Number(today.replace(/[/]/g, ''))
        var shippDay = Number(rowData.desiredShippingDate.replace(/[/]/g, ''))
        this.requestCancel = [1,2,3].indexOf(rowData.progress) != -1 && !rowData.reExaminationFlag && today < shippDay
        this.version = rowData.version
        this.$modal.show('detail-Holter-modal')
      } else if(kind.indexOf('Analysis') >= 0)  {
        if(progress == 6 || progress == 7 || progress == 100){
          this.canUpdate = true;
        } else {
          this.canUpdate = false;
        }
        this.$modal.show('detail-HolterAnalysis-modal')
      }
    },
    updateShowDetail: function() {
      var _this = this;

      this.apiCall(
        function(client){
          return client.apis.externalRequestSearch.getApplicationListPOST({
            body:{receiptNumber: _this.showDetailTargetReceiptNumber}
          });
        },
        function(result){
          if (result.obj.length > 0) {
            var index = _this.data.findIndex(row => {
              return row.receiptNumber == _this.showDetailTargetReceiptNumber
            })

            _this.data.splice(index, 1, result.obj[0])
            _this.canUpdate = false;
          }
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );

    },
    // 所属・施設情報を基にクイックオーダーで選択可能なHST機種を再取得して保持する
    refreshQuickOrderHstAvailability: function (targetRow) {
      const detailData = targetRow ? (targetRow.applicationDetails || {}) : (this.detailData || this.showDetailTargetData || {})
      const belongId = (detailData && detailData.belongsId) || (targetRow && targetRow.belongsId) || this.belongsId
      const institutionId = (detailData && detailData.institutionId) || (targetRow && targetRow.institutionId) || 0
      this.quickOrderHstModelValues = []
      if (!belongId) {
        return Promise.resolve()
      }
      return this.apiCall(
        function (client) {
          return client.apis.apiCommon.getChoicesListLinkedEstimatePOST({
            body: {
              belongId: belongId,
              institutionId: institutionId || 0
            }
          })
        },
        (result) => {
          if (!result || !Array.isArray(result.obj)) {
            this.quickOrderHstModelValues = []
            return
          }
          const enabledModels = result.obj
            .filter(item => item && item.choicesType === this.choicesType.hstKind)
            .map(item => {
              if (item && item.value !== undefined && item.value !== null) {
                return String(item.value)
              }
              return ''
            })
            .filter(value => value)
          this.quickOrderHstModelValues = enabledModels
        },
        (error) => {
          this.quickOrderHstModelValues = []
          this.showErrorMessage(error)
        }
      )
    },
    showQuickOrder: function (kind, progress, rowData) {
      this.closeDetail()
      this.closeDownLoadFileList()
      this.kindData = kind
      this.progressData = progress
      const targetRow = rowData || this.quickOrderTargetRow
      if (targetRow) {
        this.quickOrderTargetRow = targetRow
        this.showDetailTargetReceiptNumber = targetRow.receiptNumber
        this.showDetailTargetData = targetRow.applicationDetails || {}
        const type = this.getDetailTypeFromKind(targetRow.detailKind || targetRow.kind || '')
        this.detailType = type
        this.detailData = targetRow.applicationDetails || null
        this.isComplete = this.completedStatus.includes(progress)
        this.isCancel = this.cancelStatus.includes(progress)
        if (type) {
          const detailFlags = this.detailData || {}
          this.isCpap = Boolean(detailFlags.isCpap || targetRow.isCpap)
          this.canOrderWatchPat = Boolean(detailFlags.canOrderWatchPat || targetRow.canOrderWatchPat)
          this.canOrderWatchPat300 = Boolean(detailFlags.canOrderWatchPat300 || targetRow.canOrderWatchPat300)
          this.canOrderPmp300e = Boolean(detailFlags.canOrderPmp300e || targetRow.canOrderPmp300e)
          this.canOrderSleepProfiler = Boolean(detailFlags.canOrderSleepProfiler || targetRow.canOrderSleepProfiler)
          this.isFullPSG = Boolean(detailFlags.fullFlag || targetRow.fullFlag)
          this.refreshQuickOrderHstAvailability(targetRow)
        } else {
          this.resetNextPrescribeState()
        }
      }
      if (!this.detailType) {
        return
      }
      this.$modal.show('quick-order-modal')
    },
    fontSizeClass(text) {
      const len = text.length
      // 文字数に応じてフォントサイズ縮小
      if (len > 15) return "fs-9px"
      return
    },
    closeDetail: function(){
      this.$modal.hide('detail-Hst-modal')
      this.$modal.hide('detail-Psg-modal')
      this.$modal.hide('detail-Kenshin-modal')
      this.$modal.hide('detail-Holter-modal')
      this.$modal.hide('detail-HolterAnalysis-modal')
    },
    closeDownLoadFileList: function(){
      this.$modal.hide('download-modal')
    },
    closeQuickOrder: function () {
      this.$modal.hide('quick-order-modal')
    },
    showReportArea: function(rowData) {
      this.closeDetail()
      this.closeQuickOrder()
      this.fileListStr = rowData.reportFileList;
      this.targetRowData = rowData;
      this.$modal.show('download-modal')
    },
    download: function(fileId, downloadFlag) {
      if (this.fileListStr.length > 0) {
        var i = this.fileListStr.findIndex(file => file.fileId == fileId);
        if (i >= 0) {
          var updfile = JSON.parse(JSON.stringify(this.fileListStr[i]))
          updfile.downloadFlag = downloadFlag;
          this.fileListStr.splice(i, 1, updfile)
        }
      }
    },
    printDetail: function(kind, rowData) {
      this.closeDetail();
      this.closeDownLoadFileList();
      this.printTargetReceiptNumber = rowData.receiptNumber
      this.printTargetReqDate = rowData.applicationDatePrint
      this.printTargetData = rowData.applicationDetails
      this.printType = kind
      this.isAccommodations = false
      switch(kind){
        case "HST":
          this.printTitle = "睡眠検査機器配送ｻｰﾋﾞｽ（解析結果付）申込み"
          break;
        case "PSG":
          if(rowData.applicationDetails.fullFlag){
            this.printTitle = "解析申込み（フルPSG検査）"
          }else{
            this.printTitle = "解析申込み（簡易検査）"
          }
          break;
        case "企業検診":
          if(rowData.kind.indexOf("スクリーニング") != -1){
            this.printTitle = "スクリーニング検査申込み"
            this.isAccommodations = true
          }else{
            this.printTitle = "企業検診申込み"
          }
          break;
        case "Holter":
          this.printTitle = "ホルター心電図配送ｻｰﾋﾞｽ"
          break;
        case "Analysis":
          this.printTitle = "ホルター心電図解析ｻｰﾋﾞｽ"
          break;
      }
      this.isPrintModalActive = true
      this.goToTop()
    },
    print: function() {
      window.print();
    },
    showDownloadMark: function(filelist) {
      if (filelist && filelist.length > 0) {
        var target = filelist.find(file => file.downloadFlag)
        if (target) {
          return true
        }
      }
      return false
    },
    reInspection: function() {
      this.showDetailTargetData
    },
    requestHst: function (deviceName) {
      this.$router.push({ name: 'HSTRequest', params: {receiptNumber: this.showDetailTargetReceiptNumber, kind: this.kindData.toLowerCase(), deviceName} })
    },
    requestFullPsg: function () {
      this.$router.push({ name: 'PSGRequest', params: {id: 'full', receiptNumber: this.showDetailTargetReceiptNumber, kind: this.kindData.toLowerCase()} })
    },
    requestPsg: function () {
      this.$router.push({ name: 'PSGRequest', params: {id: 'easy', receiptNumber: this.showDetailTargetReceiptNumber, kind: this.kindData.toLowerCase()} })
    },
    requestCpap: function (isInstrumentFlg) {
      const params = {
        receiptNumber: this.showDetailTargetReceiptNumber,
        kind: this.kindData.toLowerCase()
      }

      if (isInstrumentFlg) {
        params.instrument = isInstrumentFlg
      }

      this.$router.push({ name: 'CpapRequest', params: params })
    },
    requestHolter: function () {
      this.$router.push({ name: 'HolterRequest', params: {receiptNumber: this.showDetailTargetReceiptNumber, kind: this.kindData.toLowerCase()} })
    },
    requestHolterInside: function () {
      if (!this.canRequestHolterInside) {
        return
      }
      this.$router.push({ name: 'HolterDepositMachineList', params: {receiptNumber: this.showDetailTargetReceiptNumber, kind: this.kindData.toLowerCase()} })
    },
    introduce: function (kind) {
      // 紹介先選択
      this.$router.push({
        name: 'IntroductionRequest',
        params: {
          prekind: this.kindData.toLowerCase(),
          kind: kind,
          receiptNumber: this.showDetailTargetReceiptNumber,
          item: this.showDetailTargetData,
          searchConditions: this.searchConditions
        }
      })
    },
    isSP: function() {
      var model = this.hstModelList.find(val => val.value == this.showDetailTargetData.model)
      if(model && model.label1 && model.label1.match(/スリーププロファイラー/)){
        return true
      }
      return false
    },
    buildPatientSummary: function (detail) {
      const summary = {
        ids: '',
        names: ''
      }
      if (!detail || typeof detail !== 'object') {
        return summary
      }
      if (Array.isArray(detail.patientsData) && detail.patientsData.length > 0) {
        const ids = []
        const names = []
        detail.patientsData.forEach(patient => {
          if (!patient) {
            return
          }
          if (patient.patientId) {
            ids.push(patient.patientId)
          }
          const name = [patient.patientFamilyName, patient.patientFirstName]
            .filter(part => part)
            .join(' ')
            .trim()
          if (name) {
            names.push(name)
          }
        })
        summary.ids = ids.join(' / ')
        summary.names = names.join(' / ')
        return summary
      }
      if (detail.patientId) {
        summary.ids = detail.patientId
      }
      const singleName = [detail.patientFamilyName, detail.patientFirstName]
        .filter(part => part)
        .join(' ')
        .trim()
      if (singleName) {
        summary.names = singleName
      } else if (detail.patientName) {
        summary.names = detail.patientName
      }
      return summary
    },
    getDeliveryTargetLabel: function (target) {
      if (target === 'home') {
        return '患者へ配送'
      }
      if (target === 'hospital') {
        return '医療機関へ配送'
      }
      return ''
    },
    resolveHstModelLabel: function (value) {
      if (value === undefined || value === null) {
        return ''
      }
      const stringValue = typeof value === 'string' ? value : String(value)
      const list = this.hstModelList || []
      const target = list.find(item => item && String(item.value) === stringValue)
      return target && target.label1 ? target.label1 : ''
    },
    normalizeBasicInfoValue: function (value) {
      if (value === undefined || value === null) {
        return ''
      }
      if (typeof value === 'string') {
        return value.trim()
      }
      if (typeof value === 'number') {
        return String(value)
      }
      if (typeof value === 'boolean') {
        return value ? '有' : '無'
      }
      if (Array.isArray(value)) {
        return value
          .map(item => this.normalizeBasicInfoValue(item))
          .filter(part => part)
          .join(' / ')
      }
      if (value instanceof Date) {
        return value.toLocaleDateString('ja-JP')
      }
      return String(value)
    },
    // サービスが利用可能で、かつモデルがある場合にのみ、ボタン表示
    canQuickOrderHst: function (model) {
      if (!this.isEnableService(this.serviceId, this.service.hst)) {
        return false
      }

      // フルPSGの時は表示しない
      const kind = this.kindData.toLowerCase();
      if(kind == "psg" && !this.isKindSimplePsg()) return false;

      if (!model) {
        return false
      }
      const rawValue = model.value || model.id || model.label1
      if (!rawValue) {
        return false
      }
      if (!Array.isArray(this.quickOrderHstModelValues) || this.quickOrderHstModelValues.length === 0) {
        return false
      }
      const value = typeof rawValue === 'string' ? rawValue : String(rawValue)
      return this.quickOrderHstModelValues.includes(value)
    },
    doCancel:  function(type, reason){
      // 検査をキャンセル
      this.reason = reason
      var excuteApi
      var successCallBack = this.setCancelPOSTSuccess;
      var errorCallBack = this.setCancelPOSTError;
      switch(type){
        case "HST":
          excuteApi = this.setHstCancelPOST;
          break;
        case "PSG":
          excuteApi = this.setPsgCancelPOST;
          break;
        case "Holter":
          excuteApi = this.setHolterCancelPOST;
          break;
      }
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHstCancelPOST: function(client) {
      var reqParam = {
        receiptNumber:this.showDetailTargetReceiptNumber,
        version:this.version,
        reason:this.reason
      }
      return client.apis.externalHst.setHstCancelPOST({
        body:reqParam
      });
    },
    setPsgCancelPOST: function(client) {
      var reqParam = {
        receiptNumber:this.showDetailTargetReceiptNumber,
        version:this.version,
        reason:this.reason
      }
      return client.apis.externalPsg.setPsgCancelPOST({
        body:reqParam
      });
    },
    setHolterCancelPOST: function(client) {
      var reqParam = {
        receptionNo:this.showDetailTargetReceiptNumber,
        version:this.version,
        reason:this.reason
      }
      return client.apis.internalHolter.setHolterReceptionInspectionCancelPOST({
        body:reqParam
      });
    },
    setCancelPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.doSearch()
    },
    setCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    // getChoicesList: function () {
    //   const unitTypes = this.getUnitTypeGroup() || []
    //   const defaultOption = { value: '', label: '' }
    //   this.unitTypeOptions = [defaultOption, ...unitTypes]
    // },
    getTableElement: function () {
      const parentElement = document.getElementById(
        'requestFormListTable'
      )
      return parentElement.getElementsByTagName('table')[0]
    },
    changeCheckBox: function (checkboxModel) {
      const width = checkboxModel.width
      const tableElement = this.getTableElement()
      let newWidth = 0
      if (checkboxModel.checked) {
        newWidth = tableElement.clientWidth + width
      } else {
        newWidth = tableElement.clientWidth - width
      }
      this.chengeTableWidth(newWidth)

      this.setColumnSelection([checkboxModel])
    },
    changeAllCheckBox: function () {
      if (this.isAllChecked) {
        this.tableWidth = 0
        Object.values(this.columns).forEach(column => {
          this.tableWidth += column.width;
        });
        this.chengeTableWidth(this.tableWidth)
      } else {
        this.chengeTableWidth(0)
      }
      Object.values(this.columns).map(clumn => {
        clumn.checked = this.isAllChecked
      })

      // 一括送信用に配列を作成
      const columnSelections = Object.values(this.columns).map(column => ({
        columnId: column.columnId,
        checked: column.checked,
        width: column.width // 必要に応じて width も含める
      }))

      // 一括送信
      this.setColumnSelection(columnSelections)
    },
    chengeTableWidth: function (width) {
      const tableElement = this.getTableElement()
      tableElement.style.width = width + 'px'
    },
    getColumnSelection: async function () {
      const _this = this

      // Web API 呼び出し
      await this.apiCall(
        function (client) {
          const obj = {
            screenName: _this.screenName
          }
          return client.apis.apiCommon.getColumnSelectionPOST({
            body: obj
          })
        },
        function (result) {
          // 結果を反映
          const response = result.body

          // screenId をセット
          _this.screenId = response.screenId

          // columns を反映
          _this.serverColumns = response.columns

          _this.serverColumns.forEach(col => {
            _this.columns[col.columnName].checked = col.displayFlag === null ? _this.columns[col.columnName].checked : col.displayFlag
            _this.columns[col.columnName].columnId = col.columnId
          });

          // 列選択の幅の設定
          _this.tableWidth = 0
          Object.values(_this.columns).forEach(column => {
            if (column.checked) _this.tableWidth += column.width;
          });
        },
        function() {
          // 列選択の幅の設定
          _this.tableWidth = 0
          Object.values(_this.columns).forEach(column => {
            if (column.checked) _this.tableWidth += column.width;
          });
          _this.showErrorMessage( "列表示状態の取得に失敗しました。<br>検索結果の列表示が初期状態となります。")
        }
      )
    },
    setColumnSelection: function (checkboxModels) {
      const _this = this
      const columnSelections = checkboxModels.map(model => ({
        screenId: _this.screenId,
        columnId: model.columnId,
        displayFlag: model.checked
      }))
      // Web API 呼び出し
      _this.apiCall(
        function (client) {
          return client.apis.apiCommon.setColumnSelectionPOST({
            body: columnSelections // 複数データをまとめて送信
          })
        },
        function (result) {
          console.log(result)
        },
        function() {
          _this.showErrorMessage( "列選択状態の保存に失敗しました。<br>画面更新後に再度ご実施ください")
        }
      )
    },
    isEnableInstitution: function(institutionName) {
      if(!this.quickOrderTargetRow || !this.kindData) return false;

      const kind = this.kindData.toLowerCase();

      if (institutionName === 'hst') return kind === 'holter';
      
      if (institutionName === 'psg') {
        if (kind === 'holter') return true;
        return this.isKindSimplePsg()
      }

      return false;
    },
    filesExpiredCheck(files) {
      // null/undefined は未削除扱い
      if (!Array.isArray(files)) return false;

      // 空配列は「すべて削除済み」ではない（false）
      if (files.length === 0) return false;

      // すべて true のときのみ true（オプショナルチェーンを使わない）
      return files.every(file => file && file.s3DeleteFlag === true);
    },
    checkConnectionBtn(serviceId, checkServiceId, checkServiceName){
      if(!this.isEnableService(serviceId, checkServiceId)) return false;

      const kind = this.kindData.toLowerCase();
      if(checkServiceId == 2){
        if(kind == "hst"){
          if(this.isKindSimplePsg()){
            if(checkServiceName == "フルPSG解析") return true;
            if(checkServiceName == "簡易PSG解析") return false;
          }else{
            return false;
          }
        } else if(kind == "psg"){
          if(checkServiceName == "フルPSG解析") return true;
          if(checkServiceName == "簡易PSG解析") return false;
        }
      }

      return true;
    },
    isKindSimplePsg(){
      const kind = this.kindData.toLowerCase();
      const choiceMaster = JSON.parse(sessionStorage.getItem("choiceMaster"));
      const instrument = this.quickOrderTargetRow.instrumentKind || '';
      let label3 = '';

      // kindに応じてchoicesTypeを切り替え
      const targetType = kind === 'hst' ? "1" : kind === 'psg' ? "2" : null;

      if (targetType) {
        const typeObj = choiceMaster.find(item => item.choicesType === targetType);
        const targetChoices = typeObj ? typeObj.choicesList : [];
        const matchedChoice = targetChoices.find(choice => choice.label1 === instrument);
        label3 = matchedChoice ? matchedChoice.label3 : '';
      }

      return label3 === "簡易PSG";
    },
    
    async getDepositMachineNumber(){
      let excuteApi = this.getHolterDepositMachineRequestPOST;
      let successCallBack = this.getHolterDepositMachineRequestPOSTSuccess;
      let errorCallBack = this.getHolterDepositMachineRequestPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack) 
    },
    getHolterDepositMachineRequestPOST: function(client) {
      return client.apis.externalHolter.getHolterDepositMachineRequestPOST({
        body:{
          belongsId: this.userInfo.belongsId
        }
      });
    },
    getHolterDepositMachineRequestPOSTSuccess: function(result) {
      let depositRequest = result.obj
      this.rentalNumber = depositRequest.rentalNumber
    },
    getHolterDepositMachineRequestPOSTError: function(result) {
      this.showErrorMessage(result);
    },
  },
  data () {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let roleId = userInfo.roleId;
    let isHospital = roleId == role.role_hospital;
    let serviceId = userInfo.useServiceId;
    let progressList = this.getProgressList();
    var completedStatus = [
      requestStatus.completion,
      requestStatus.salesAppropriation,
      requestStatus.completionAppropriation,
      requestStatus.holterJudgmentRequest,
      requestStatus.holterJudgmentReady
    ]
    var cancelStatus = [
      requestStatus.cancel,
      requestStatus.completionNotAppropriation
    ]
    progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.deposit_regist + ']';
    });
    progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.depositMachine + ']';
    });
    progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.depositMachineReturnWait + ']';
    });
    progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.depositMachineRelease + ']';
    });
    if(!this.isEnableService(serviceId, service.hst) && !this.isEnableService(serviceId, service.holter)){
      //HST、ホルターを行わないユーザーの場合は、「再検査調整中」を表示しない
      progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.reInspection + ']';
      });
    }
    if(!this.isEnableService(serviceId, service.psg)){
      //PSG解析を行わないユーザーの場合は、「差換え依頼中」を表示しない
      progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.replaceFile + ']';
      });
    }
    let kindList = this.getKindGroup()
    let hstModelList = this.getChoiceList(choicesType.hstKind, true);
    let preSearchConditions = this.$route.params["searchConditions"];
    let isFromHolterPatientReportRedirect = this.$route.params["isFromHolterPatientReportRedirect"];
    let tempSearchReceptionNo = this.$route.params["tempSearchReceptionNo"];
    let taskSearchConditions = this.$route.params["taskSearchConditions"];
    //申込日のデフォルト値
    let applicationDateStartDate = new Date();
    applicationDateStartDate.setMonth(applicationDateStartDate.getMonth() - 6);
    let applicationDateStart = this.yyyy_hyp_MM_hyp_dd(applicationDateStartDate);
    let applicationDateEndDate = new Date();
    let applicationDateEnd = this.yyyy_hyp_MM_hyp_dd(applicationDateEndDate);
    // 列選択機能
    const columns = {
      receiptNumber: { checked: true, width: 100 },
      kind: { checked: false, width: 100 },
      instrumentKind: { checked: true, width: 150 },
      snoreSensor: { checked: false, width: 70 },
      hospital: { checked: !isHospital, width: 180 },
      patientId: { checked: true, width: 80 },
      patientName: { checked: true, width: 110 },
      applicationDate: { checked: true, width: 90 },
      completionDate: { checked: true, width: 90 },
      progress: { checked: true, width: 100 },
      ahi: { checked: true, width: 50 },
      cvhri: { checked: true, width: 70 },
      report: { checked: true, width: 60 },
      quickOrder: { checked: isHospital, width: 60 },
      print: { checked: true, width: 80 },
      contact: { checked: true, width: 100 }
    }
    // Object.values(columns).map(clumn => {
    //   if (clumn.checked) tableWidth += clumn.width
    // })
    return {
      detailType: null,
      detailData: null,
      kindData: '',
      progressData: null,
      isCpap: false,
      canOrderWatchPat: false,
      canOrderWatchPat300: false,
      canOrderPmp300e: false,
      canOrderSleepProfiler: false,
      isFullPSG: false,
      quickOrderHstModelValues: [],
      quickOrderTargetRow: null,
      detailQuickOrderRow: null,
      unitTypeOptions: [],
      instrumentKindOptions: [],
      service: service,
      serviceId: serviceId,
      isHospital: isHospital,
      choicesType:choicesType,
      data: [],
      isPaginated: true,
      canUpdate: false,
      isComplete: false,
      isCancel: false,
      fileListStr:"",
      targetRowData: {},
      belongsId:userInfo.belongsId,
      progressList,
      completedStatus,
      cancelStatus,
      kindList,
      hstModelList: hstModelList,
      preSearchConditions,
      searchConditions:{
        receiptNumber:"",
        kind:[],
        instrumentKind: "",
        progress:[],
        hospital:"",
        patientId:"",
        patientName:"",
        applicationDateStart:applicationDateStart,
        applicationDateEnd:applicationDateEnd,
        completionDateStart:"",
        completionDateEnd:"",
        downloadFlag:"",
        snoreSensor:"",
        ahiFrom: "",
        ahiTo: "",
        cvhriFrom: "",
        cvhriTo:"",
        cvhriFlag: 0,
        returnDelay: false
      },
      taskSearchConditions: taskSearchConditions,
      showDetailTargetData:{},
      showDetailTargetReceiptNumber:"",
      reset: 0,
      reSearchFlag:false,
      printTargetData:{},
      isPrintModalActive:false,
      printTargetReceiptNumber:"",
      printTargetReqDate:"",
      printType:"",
      printTitle:"",
      isAccommodations:false,
      requestCancel:false,
      version:null,
      reason:"",
      dataBlank: false,
      columns: columns,
      tableWidth: 0,
      isOpen: false,
      screenName: 'requestFormList',
      screenId: null,
      serverColumns: null,
      userInfo,
      rentalNumber:0,
      isFromHolterPatientReportRedirect,
      tempSearchReceptionNo,
      isFirstAutoSearch: isFromHolterPatientReportRedirect,
    }
  },
  filters: {
    snoreSensorFilter(value){
      if (value == "1") {
        return "無"
      } else if (value == "2") {
        return "有"
      } else {
        return "-"
      }
    },
  },
  computed: {
    // クイックオーダー用の自宅配送用ボタン配置用の機種取得およびサニタイズ
    homeDeliveryHstGroups () {
      const groups = {
        easy: [],
        full: []
      }
      if (!Array.isArray(this.hstModelList)) {
        return groups
      }
      const normalizeLabel = (label) => {
        if (typeof label !== 'string') {
          return ''
        }
        let sanitized = label.replace(/【簡易検査】|【フルPSG】/g, '').trim()
        if (!sanitized) {
          sanitized = label.trim()
        }
        return sanitized === 'スマートウォッチ PMP-300E' ? 'PMP-300E' : sanitized
      }
      this.hstModelList.forEach(model => {
        if (!model || model.deleteFlag) {
          return
        }
        const normalizedModel = {
          ...model,
          label1: normalizeLabel(model.label1 || '')
        }
        if (model.label3 === '簡易PSG') {
          groups.easy.push(normalizedModel)
        } else if (model.label3 === 'フルPSG') {
          groups.full.push(normalizedModel)
        }
      })
      return groups
    },
    filteredInstrumentKindOptions () {
      if (!this.selectedKindLabel) {
        return this.instrumentKindOptions
      }
      const isCorporateSelection = isCorporateKindLabel(this.selectedKindLabel)
      return this.instrumentKindOptions.filter((option) => {
        if (isCorporateSelection) {
          return option.kindLabel === CORPORATE_KIND_LABEL
        }
        return option.kindLabel === this.selectedKindLabel
      })
    },
    selectedKindLabel () {
      if (!this.searchConditions || !Array.isArray(this.kindList)) {
        return ''
      }
      const normalizeValue = (value) => {
        if (value === undefined || value === null) {
          return ''
        }
        if (typeof value === 'string') {
          return value
        }
        try {
          return JSON.stringify(value)
        } catch (error) {
          console.error(error)
          return ''
        }
      }
      const currentValue = normalizeValue(this.searchConditions.kind)
      if (!currentValue) {
        return ''
      }
      const selected = this.kindList.find(
        item => normalizeValue(item.value) === currentValue
      )
      return selected ? selected.label : ''
    },
    quickOrderDetailSource () {
      return this.detailData || this.showDetailTargetData || {}
    },
    quickOrderBasicInfoRows () {
      const rows = []
      const type = this.detailType
      const detail = this.quickOrderDetailSource || {}
      if (!type || !detail || typeof detail !== 'object') {
        return rows
      }
      const hasData = Object.keys(detail).length > 0
      if (!hasData) {
        return rows
      }
      const targetRow = this.quickOrderTargetRow || {}
      const pushRow = (label, value) => {
        const normalized = this.normalizeBasicInfoValue(value)
        if (normalized) {
          rows.push({ label, value: normalized })
        }
      }
      pushRow('受付番号', this.showDetailTargetReceiptNumber || targetRow.receiptNumber)
      pushRow('種別', targetRow.detailKind || targetRow.kind || type)
      pushRow('医療機関名', detail.hospitalName || targetRow.hospital)
      pushRow('医師名', detail.doctorName)
      pushRow('事務員名', detail.clerkName)
      const patientSummary = this.buildPatientSummary(detail)
      pushRow('診察券ID', patientSummary.ids)
      pushRow('患者名', patientSummary.names)
      switch (type) {
        case 'HST':
          pushRow('機種', this.resolveHstModelLabel(detail.model) || targetRow.instrumentKind)
          pushRow('配送先', this.getDeliveryTargetLabel(detail.delivaryTarget))
          pushRow('出荷予定日', detail.shippingDate || targetRow.desiredShippingDate)
          break
        case 'PSG':
          pushRow('検査種別', detail.inspectionType || targetRow.detailKind || targetRow.kind)
          pushRow('解析方法', detail.analysisMethod)
          pushRow('返却希望日', detail.returnDate)
          pushRow('レポート形式', detail.reportFormat)
          break
        case 'Holter':
        case 'Analysis':
          pushRow('機種', detail.instrumentKind || detail.model || targetRow.instrumentKind)
          pushRow('検査期間', detail.inspectionPeriodLabel || detail.inspectionPeriod)
          pushRow('返却日', detail.returnDate)
          break
        case 'Kenshin':
          pushRow('企業名', detail.companyName || detail.corporateName)
          pushRow('担当者', detail.personInCharge || detail.clerkName)
          break
        default:
          pushRow('機種', detail.instrumentKind || detail.model || targetRow.instrumentKind)
      }
      pushRow('申込日', targetRow.applicationDate)
      const progressLabel = typeof this.getProgres === 'function'
        ? this.getProgres(targetRow.progress)
        : ''
      pushRow('進捗状況', progressLabel)
      return rows
    },
    shouldShowQuickOrderDetail () {
      if (!this.detailType) {
        return false
      }
      const detail = this.quickOrderDetailSource
      if (!detail || typeof detail !== 'object') {
        return false
      }
      return Object.keys(detail).length > 0
    },
    canRequestHolterInside () {
      if (!this.isEnableService(this.serviceId, this.service.holter)) {
        return false
      }

      //ホルター心電図院内貸出を実施するかどうかのチェック
      if(!this.userInfo.holterUseDepositFlg) return false

      //貸出台数を確認
      if(this.rentalNumber >= 1) return true;

      return false;
    },
  },
  watch: {
    'searchConditions.kind': function () {
      this.ensureInstrumentKindInCurrentFilter()
    },
    instrumentKindOptions: function () {
      this.ensureInstrumentKindInCurrentFilter()
    }
  },
  components: {
    floatingModal:floatingModal,
    hstRequestDetail:HSTRequestDetail,
    psgRequestDetail:PSGRequestDetail,
    kenshinRequestDetail:KenshinRequestDetail,
    holterRequestDetail:HolterRequestDetail,
    holterAnalysisRequestDetail:HolterAnalysisRequestDetail,
    downLoadFileList:DownLoadFileList,
    FileListHospitalDialog,
  },
  async mounted () {
    await this.getColumnSelection()
    await this.prepareInstrumentKindOptions()
    // await this.getChoicesList()
    if (this.preSearchConditions) {
      this.searchConditions = this.preSearchConditions
      this.preSearchConditions = {}
      this.doSearch()
    }else if (this.taskSearchConditions) {
      for (const key in this.taskSearchConditions) {
        if(key === "kind"){
          const values = this.kindList.filter(item => this.taskSearchConditions[key].includes(item.label)) || {}.map(item => item.value);
          const merged = values
            .map(item => JSON.parse(item.value))
            .flat();
          this.searchConditions[key] = JSON.stringify(merged);
        } else if (Object.prototype.hasOwnProperty.call(this.searchConditions, key)) {
          this.searchConditions[key] = this.taskSearchConditions[key];
        }
      }
      this.searchConditions.applicationDateStart = "";
      this.searchConditions.applicationDateEnd = "";
      this.doSearch();
    }

    // ホルター解析承認後に送られるメールからの遷移用処理
    if (this.isFromHolterPatientReportRedirect) {
      this.searchConditions.receiptNumber = this.tempSearchReceptionNo
      this.searchConditions.applicationDateStart = ""
      this.searchConditions.applicationDateEnd = ""
      this.tempSearchReceptionNo = ""
      this.doSearch()
    }

    // 医療機関なら院内貸出台数を取得
    if(this.isHospital) this.getDepositMachineNumber();
  }
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}

#item-contens table tr th {
  width: 70px;
}

#item-contens table tr td button {
  width: 165px;
  margin-right: 3px;
}
.button-group{
  margin-top:2px;
}
.file-dialog {
  z-index: 20;
}

.row {
  display: grid;
  grid-template-columns: 150px 1fr;
  align-items: center;
  padding: 5px 5px;

}

.row-spacer {
  position: relative;
  height: 1rem;
}

.row-spacer::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #000;
  transform: translateY(-50%);
}

.row-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.row-label {
  width: 150px;
  font-weight: 500;
}

.btn { border: none !important;}

.btn[disabled],
.btn:disabled {
  background: #a8adb8 !important;
  color: #fff !important;
  border-color: #a8adb8 !important;
  cursor: not-allowed;
  filter: none;
  opacity: 1;
}

.button.btn:hover { filter: brightness(1.1); }

.btn--blue1 { background: #002C77 !important; color: #fff !important; }
.btn--blue2 { background: #004EAA !important; color: #fff !important; }
.btn--blue3 { background: #0077CD !important; color: #fff !important; }
.btn--blue4 { background: #85CCFF !important; color: #fff !important; }
.btn--green { background: #269A91 !important; color: #fff !important; }

.selectColumn {
  width: 800px;
  position: absolute;
  background-color: white;
  z-index: 25;
}

.next-prescription-bar {
  position: absolute;
  width: calc(100% - 35px) !important;
  top: 50px;
  left: 8px;
  background-color: #fff;
  z-index: 5;
}

.next-prescription-bar::before{
  content: "";
  display: block;
  position: absolute;
  bottom: calc(100% + 1px);
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% + 3px);
  height: 10px;
  background: white;
}

.next-prescription-bar-top{
  margin-top: 72.5px
}

.quick-order-basic-info {
  max-height: 200px;
  overflow-y: auto;
}

.quick-order-basic-info table tr th {
  width: 120px;
}

.quick-order-basic-info table tr td {
  word-break: break-word;
  white-space: pre-wrap;
}

.quick-order-request-detail {
  margin-top: 20px;
  padding: 10px;
  background-color: #f5f6fa;
  border-radius: 4px;
}

.btn--expired{
  background: #a8adb8 !important;
  color: #fff !important;
  border-color: #a8adb8 !important;
  -webkit-filter: none;
  filter: none;
  opacity: 1;
}
</style>
<style lang="scss">
.btn-item span {
  display: inline-block;
}
/* 文字列長に応じてフォントサイズを変更 */
.fs-9px span {
  font-size: 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/RequestFormList.vue